import { schema } from 'normalizr';
import { SCHEMA_TYPE_SDK_APPLICATION } from '../constants/schemaTypes';

export const sdkApplicationSchema = new schema.Entity(
  SCHEMA_TYPE_SDK_APPLICATION,
  {},
  {
    processStrategy: ({ service_key, ...entity }) => entity,
  },
);
